import React from "react";
import { homeData } from "../../data/homeData";
import { assetPath } from "../../utils/assetPath";
import LogoLoop from "../common/LogoLoop";
import GradientLine from "../common/GradientLine";

const ProofAndStandards = () => {
  const { clients, compliance } = homeData;
  const { list } = clients;

  const logos = list.map((client) => ({
    src: assetPath(client.logo),
    alt: client.name,
    title: client.name,
  }));

  return (
    <section className="relative overflow-hidden flex flex-col items-center justify-center bg-white">
      {/* Top Gradient Line */}
      <div className="w-full flex justify-center mb-16">
        <GradientLine />
      </div>

      {/* Trusted By Label */}
      <div className="text-center mb-8 relative z-10 flex flex-col items-center gap-3">
        <p className="text-[#181C20] text-[22px] sm:text-[32px] md:text-[42px] lg:text-[50px] font-black tracking-widest">
          Trusted by Industry Leaders
        </p>
        <div className="w-24 h-px bg-linear-to-r from-transparent via-blue-400/50 to-transparent" />
      </div>

      <div className="relative overflow-hidden w-full max-w-[1400px] h-[40px] sm:h-[50px] md:h-[60px]">
        <LogoLoop
          logos={logos}
          speed={80}
          direction="left"
          logoHeight={28}
          gap={40}
          pauseOnHover
          hoverSpeed={0}
          scaleOnHover
          fadeOut
          fadeOutColor="#ffffff"
          ariaLabel="Trusted industry partners"
          renderItem={(item) => (
            <div className="flex items-center justify-center w-[90px] sm:w-[120px] md:w-[160px] h-[28px] sm:h-[36px] md:h-[40px] px-2 sm:px-4 transition-transform duration-300 group-hover/item:scale-105">
              <img
                src={item.src}
                alt={item.alt}
                title={item.title}
                loading="lazy"
                className="max-w-full max-h-full object-contain opacity-80 hover:opacity-100 transition-opacity duration-300"
                onError={(e) => {
                  e.target.style.display = "none";
                  e.target.parentNode.innerHTML = `<span class="text-slate-400 text-[10px] font-bold text-center">${item.alt}</span>`;
                }}
              />
            </div>
          )}
        />
      </div>

      {/* Compliant With Chips */}
      <div className="mt-12 text-center max-w-[1400px] mx-auto px-6 flex flex-col items-center">
        <div className="flex flex-col items-center gap-3 mb-8">
          <p className="text-[#181C20] text-[14px] sm:text-[18px] md:text-[22px] lg:text-[25px] tracking-[0.15em] sm:tracking-[0.25em] md:tracking-[0.1em] font-black">
            {compliance.title}
          </p>
          <div className="w-24 h-px bg-linear-to-r from-transparent via-blue-400/50 to-transparent" />
        </div>
        <div className="flex flex-wrap items-center justify-center gap-3 max-w-4xl mx-auto pb-12">
          {compliance.standards.map((std, i) => (
            <span
              key={i}
              className="px-4 py-2 rounded-xl bg-slate-50 border border-slate-200 text-slate-700 text-[12px] font-bold tracking-tight hover:border-blue-400/60 hover:bg-blue-50 hover:text-blue-600 transition-all duration-300"
            >
              {std}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProofAndStandards;
